import React from 'react'
import Home from '../views/Home/v2/HomeV2'
import ImportItemsPage from '../views/ImportItems/ImportItemsPage'
import PrintPage from '../views/PrintPage/PrintPage'
import ShipPage from '../views/ShipPage/ShipPage'
import CheckPage from '../views/CheckPage/components/CheckPage'
import PrintQRPage from '../views/QRCode/components/PrintQRPage'
import ListNextBoxesContainer from "../views/ListNextBoxes/components/ListNextBoxesContainer"
import ExportQRItems from './../views/ExportQRItems/ExportQRItems'
import SkuContainer from '../views/SkuPage/SkuContainer'
import OrdersReportContainer from '../views/OrdersReport/OrdersReportContainer'
import PriorityStorePageContainer from '../views/PriorityStore/components/PriorityStorePageContainer'
import ReGenerateLabelsContainer from '../views/ReGenerateLabels/components/ReGenerateLabelsContainer'
import BatchShipPageContainer from '../views/BatchShip/Components/BatchShipPageContainer'
import BrandsRulePageContainer from '../views/BrandsRule/components/BrandsRulePageContainer'
import SettingShippingRuleContainer from '../views/SettingShippingRule/components/SettingShippingRuleContainer'
import ListItemMarkErrorContainer from '../views/ListItemMarkError/components/ListItemMarkErrorContainer'
import StaticOverviewContainer from "../views/StaticsOverview/components/StaticOverviewContainer"
import UsersStaticsDetailContainer from '../views/UsersStaticsDetail/components/UsersStaticsDetailContainer'
import ProductionProcess from '../views/ProductionProcess/components/ProductionProcessContainer'
import IssuesManagementContainer from '../views/IssuesManagement/components/IssuesManagementContainer'
import CombineShipPageContainer from '../views/CombineShip/Components/CombineShipPageContainer'
import JobsContainer from '../views/Jobs/components/JobsContainer'
import BoxLabelPage from '../views/BoxLabelPage/BoxLabelPage'

const iconHome = <i className="icon-home4"/>
const iconImport = <i className='icon-download4'/>
const iconPrintList = <i className='icon-printer'/>
const iconShipList = <i className='icon-truck'/>
const iconCheck = <i className='icon-vector'/>
const iconQRcode = <i className='icon-qrcode'/>
const iconBox2 = <i className='icon-dropbox icon-red'/>
const iconExportQRItems = <i className='icon-download'/>
const iconSku = <i className='icon-cog2'/>
const iconReport = <i className='icon-stats-dots'/>
const iconReGen = <i className='icon-price-tag3'/>
const iconPriorityStore = <i className="fa fa-level-up fa-lg" />
const iconShipment = <i className="icon-cabinet" />
const iconBrand = <i className="fa fa-bookmark" />
const iconRulers = <i className='fa fa-list-ul' />
const iconReports = <i className="fa fa-list-alt" />
const iconStaticDetail = <i className="fa fa-folder-open" />
const iconStaticOverview = <i className="fa fa-line-chart" />
const iconItemError = <i className="fa fa-tasks" />
const iconProductProcess = <i className="fa fa-wrench"/>
const iconIssue = <i className="fa fa-exclamation-triangle" />
const iconCombineShip = <i className="fa fa-cubes"></i>
const iconJob = <i class="fa fa-file" />
const iconBoxLabel = <i className="fa fa-tag" />

const viewsRoutes = [
    {
        path: '/',
        exact: true,
        name: 'Home',
        icon: iconHome,
        component: Home
    },
    {
        path: '/import-items',
        name: 'Import Items',
        icon: iconImport,
        component: ImportItemsPage
    },
    {
        path: '/print',
        name: 'Print Item',
        icon: iconPrintList,
        component: PrintPage
    },
    {
        path: '/ship',
        name: 'Ship Item',
        icon: iconShipList,
        component: ShipPage
    },
    {
        path: '/box-label',
        name: 'Dán Label Thùng',
        icon: iconBoxLabel,
        exact: true,
        component: BoxLabelPage,
    },
    {
        path: '/shipping-rule',
        name: 'Shipping-rule',
        icon: iconRulers,
        exact: true,
        component: SettingShippingRuleContainer,
        roles: ['fac_admin', 'fac_ffm'],
    },
    {
        path: '/check',
        name: 'Check',
        icon: iconCheck,
        component: CheckPage
    },
    {
        path: '/qrcode',
        name: 'PrintQRPage',
        icon: iconQRcode,
        component: PrintQRPage
    },
    {
        path: '/next-boxes',
        name: 'NextBox',
        icon: iconBox2,
        exact: true,
        component: ListNextBoxesContainer,
    },
    {
        path: '/batch-ship',
        name: 'Batch Ship Management',
        icon: iconShipment,
        exact: true,
        component: BatchShipPageContainer,
    },
    {
        path: '/export-qr-items',
        name: 'Xuất QR code',
        icon: iconExportQRItems,
        exact: true,
        component: ExportQRItems,
    },
    {
        path: '/re-generate-labels',
        name: 'Re Generate Labels',
        icon: iconReGen,
        exact: true,
        component: ReGenerateLabelsContainer
    },
    {
        path: '/orders-report',
        name: 'Orders Report',
        icon: iconReport,
        exact: true,
        component: OrdersReportContainer,
    },
    {
        path: '/priority-store',
        name: 'Danh sách ưu tiên',
        icon: iconPriorityStore,
        exact: true,
        component: PriorityStorePageContainer,
        roles: ['fac_admin', 'fac_ffm'],
    },
    {
        path: '/sku-manager',
        name: 'Quản lý SKU',
        icon: iconSku,
        exact: true,
        component: SkuContainer,
    },
    {
        path: '/jobs',
        name: 'Quản lý job export',
        icon: iconJob,
        exact: true,
        component: JobsContainer,
    },
    {
        path: '/brands-rule',
        name: 'Brands Rule Management',
        icon: iconBrand,
        exact: true,
        component: BrandsRulePageContainer,
        roles: ['fac_admin', 'fac_ffm']
    },
    {
        path: '/production-process',
        name: 'Quản lý quy trình sản xuất',
        icon: iconProductProcess,
        exact: true,
        component: ProductionProcess,
    },
    {
        path: '/issues-management',
        name: 'Quản lý đơn lỗi',
        icon: iconIssue,
        exact: true,
        component: IssuesManagementContainer,
    },
    {
        path: '/combine-ship',
        name: 'Quản lý đơn gộp ship',
        icon: iconCombineShip,
        exact: true,
        component: CombineShipPageContainer
    },
    {
        path: '',
        name: 'Report',
        icon: iconReports,
        items : [
            {
                path: '/items-mark-error',
                name: 'Thống kê item lỗi QC',
                icon: iconItemError,
                exact: true,
                component: ListItemMarkErrorContainer
            },
            {
                path: '/static-overview',
                name: 'Statics Overview',
                icon: iconStaticOverview,
                exact: true,
                component: StaticOverviewContainer
            },
            {
                path: '/users-statics-detail',
                name: 'Báo cáo chi tiết',
                icon: iconStaticDetail,
                exact: true,
                component: UsersStaticsDetailContainer
            }
        ],
        roles: ['fac_admin']
    }
]

export default viewsRoutes
